export default __webpack_public_path__ + "static/sarah-6bf000749755f0d4685189a643565cc4.png";